if (document.querySelector('.js-select-simple')) {
  document.querySelectorAll('.js-select-simple .select-options').forEach(elem => {
    $(elem).mCustomScrollbar();
  })
}